<div class="txt" *ngIf="adr.name">
    {{ adr.name }} <br> {{ adr.mobile }} <br> {{ adr.address1 }} <br>
    <span [hidden]="!adr.address2">{{ adr.address2 }}</span> {{ adr.suburb }} {{ adr.state }} {{ adr.postcode }}
    <div [hidden]="!adr.instructions">{{ adr.instructions }}</div>
</div>

<div *ngIf="!adr.name">
    (no address)
</div>